function initMediaGalleryTuxmat() {
	const root = document.querySelector('[id^="ProductMediaGallery-"]');
	if (!root) return;

	const thumbsEl = root.querySelector(".product-media-gallery-thumbs");
	const galleryEl = root.querySelector(".product-media-gallery");
	if (!thumbsEl || !galleryEl) return;

	if (thumbsEl.swiper) thumbsEl.swiper.destroy(true, true);
	if (galleryEl.swiper) galleryEl.swiper.destroy(true, true);

	const productMediaGalleryThumbs = new Swiper(thumbsEl, {
		direction: "horizontal",
		spaceBetween: 6,
		slidesPerView: 5,
    freeMode: true,
		watchSlidesProgress: true,
		loop: false,
		observer: true,
		observeParents: true,
		observeSlideChildren: true,
		mousewheel: { enabled: true, releaseOnEdges: true, sensitivity: 1 },
		keyboard: { enabled: true },
		breakpoints: {
			768: { slidesPerView: "auto", slidesPerView: 6 },
			1024: { slidesPerView: "auto", slidesPerView: 7 }
		}
	});

	new Swiper(galleryEl, {
		lazy: true,
		direction: "horizontal",
    spaceBetween: 10,
		loop: false,
		observer: true,
		observeParents: true,
		observeSlideChildren: true,
		keyboard: { enabled: true },
    navigation: {
			nextEl: root.querySelector(
				".product-media-gallery__outer-wrapper .swiper-button-next"
			),
			prevEl: root.querySelector(".product-media-gallery__outer-wrapper .swiper-button-prev")
		},
		thumbs: { swiper: productMediaGalleryThumbs }
	});
}

document.addEventListener("DOMContentLoaded", function () {
	initMediaGalleryTuxmat();
});

subscribe(PUB_SUB_EVENTS.variantChange, () => {
	initMediaGalleryTuxmat();
});
